import { EmailEditorDevice, useEmailEditorDevice } from "./EmailEditorDeviceContext";

export interface EmailEditorCapabilities {
  creationMethodPicker: boolean;
  contactImport: boolean;
  sendTestEmailInFooter: boolean;
}

export const getEmailEditorCapabilities = (device: EmailEditorDevice): EmailEditorCapabilities => {
  const isMobile = device === EmailEditorDevice.Mobile;

  return {
    creationMethodPicker: !isMobile,
    contactImport: !isMobile,
    sendTestEmailInFooter: !isMobile,
  };
};

export const useEmailEditorCapabilities = (): EmailEditorCapabilities => {
  return getEmailEditorCapabilities(useEmailEditorDevice());
};
